import { canonicalRole, isAdminType } from './roleUtils';

// Where a blocked student lands instead of Discovery. Never '/': the login page sends every
// logged-in student on to Discovery, so redirecting there would loop.
export const BLOCKED_STUDENT_ROUTE = '/profile';

// Mirrors the backend's discoveryAuth: platform admins, and students whose registration is not
// blocked (pending registrations included). Returns null when the user may open Discovery
// (and with it Discovery AI), otherwise the route to send them to.
export const getDiscoveryRedirect = (user) => {
    if (isAdminType(user?.role)) return null;
    if (canonicalRole(user?.role) !== 'student') return '/';
    return user.registrationStatus === 'blocked' ? BLOCKED_STUDENT_ROUTE : null;
};
